import { Box, Typography } from '@mui/material'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { P2PPrimaryButton, P2PSecondaryButton } from '../P2PButtons'
import { styles } from './ReportingOverview.styles'

interface Props {
  canSubmit: boolean
  onAddDistrict: () => void
  onSubmit: () => void
}

export const OverviewActions = ({ canSubmit, onAddDistrict, onSubmit }: Props): JSX.Element => (
  <Box sx={styles.actionsCard}>
    <Box sx={styles.actionsBlock}>
      <Typography variant='h4' sx={styles.actionsTitle}>Add Another District</Typography>
      <P2PSecondaryButton fullWidth endIcon={<ArrowForwardIcon />} onClick={onAddDistrict} dataTestId='p2pAddDistrict'>
        Add a District
      </P2PSecondaryButton>
    </Box>
    <Box sx={styles.actionsBlock}>
      <Typography variant='h4' sx={styles.actionsTitle}>Ready to Submit?</Typography>
      <P2PPrimaryButton fullWidth endIcon={<ArrowForwardIcon />} disabled={!canSubmit} onClick={onSubmit} dataTestId='p2pSubmitReport'>
        Submit Report
      </P2PPrimaryButton>
    </Box>
  </Box>
)
